var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g3, _path28, _path29, _path30, _path31, _path32, _path33, _g4, _path34, _path35, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 152,
    viewBox: "0 0 170 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4475 128.5C120.188 128.5 148.35 100.294 148.35 65.5C148.35 30.7061 120.188 2.5 85.4475 2.5C50.7074 2.5 22.5449 30.7061 22.5449 65.5C22.5449 100.294 50.7074 128.5 85.4475 128.5Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_804_55023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.717 57.2614L126.581 112.909C125.822 114.811 123.67 115.699 121.898 114.937L68.1087 93.7685C66.2102 93.0078 65.3244 90.8529 66.0837 89.0783L94.0545 17.8389C94.8139 15.9375 96.9655 15.0501 98.7374 15.8107L137.719 31.1487L147.717 57.2614Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.417 91.8618L91.1437 79.1857C90.6374 79.059 90.5109 78.552 90.6374 78.0449C90.764 77.5379 91.2702 77.4111 91.7765 77.5379L124.051 90.214C124.557 90.3407 124.683 90.8477 124.557 91.3548C124.304 91.735 123.797 91.9886 123.417 91.8618Z",
    fill: "#E3EAF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.091 77.5417L81.3956 75.2601C80.8894 75.1333 80.7628 74.6262 80.8894 74.1192C81.0159 73.6121 81.5223 73.4854 82.0285 73.6121L87.7239 75.8938C88.2301 76.0206 88.3567 76.5276 88.2301 77.0347C88.1036 77.5417 87.5973 77.6685 87.091 77.5417Z",
    fill: "#E3EAF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.707 83.1205L112.278 77.4163C111.772 77.2896 111.646 76.7825 111.772 76.2755C111.899 75.7684 112.405 75.6416 112.912 75.7684L127.34 81.4726C127.846 81.5994 127.973 82.1064 127.846 82.6135C127.72 83.1205 127.214 83.2472 126.707 83.1205Z",
    fill: "#E3EAF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.204 75.0112L85.1944 66.7718C84.6882 66.645 84.5617 66.1379 84.6882 65.6309C84.8148 65.1239 85.321 64.9971 85.8273 65.1238L106.837 73.3634C107.343 73.49 107.47 73.9971 107.344 74.5041C107.217 75.0112 106.71 75.138 106.204 75.0112Z",
    fill: "#E3EAF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.376 74.5008L124.808 72.3459C124.302 72.2191 124.175 71.7121 124.302 71.205C124.428 70.6981 124.934 70.5713 125.441 70.6981L131.01 72.853C131.516 72.9798 131.643 73.4868 131.516 73.9938C131.39 74.5008 130.882 74.6276 130.376 74.5008Z",
    fill: "#E3EAF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.622 70.1907L88.8664 58.0217C88.3601 57.8949 88.2335 57.3879 88.3601 56.8808C88.4866 56.3738 88.993 56.2471 89.4992 56.3739L120.255 68.5428C120.761 68.6696 120.887 69.1767 120.761 69.6836C120.634 70.1907 120.128 70.4443 119.622 70.1907Z",
    fill: "#E3EAF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1945 91.7394L93.296 90.9787C92.7898 90.8519 92.6632 90.345 92.7898 89.8379C92.9163 89.3309 93.4226 89.2041 93.9289 89.3309L95.8273 90.0914C96.3336 90.2182 96.4601 90.7253 96.3336 91.2323C96.0805 91.7394 95.5742 91.866 95.1945 91.7394Z",
    fill: "#E3EAF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7493 89.5851L78.3586 85.0217C77.8523 84.895 77.7257 84.3879 77.8523 83.8809C77.9788 83.3739 78.4852 83.2471 78.9914 83.3738L90.3822 87.9373C90.8884 88.064 91.015 88.571 90.8884 89.0781C90.7619 89.5851 90.1291 89.7119 89.7493 89.5851Z",
    fill: "#E3EAF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.174 65.8809L114.304 58.0217C113.798 57.8949 113.671 57.3879 113.798 56.8808C113.924 56.3738 114.43 56.2471 114.936 56.3739L134.807 64.2329C135.313 64.3597 135.44 64.8668 135.313 65.3738C135.187 65.8809 134.554 66.0077 134.174 65.8809Z",
    fill: "#E3EAF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.851 55.4851L92.5362 49.4007C92.03 49.2739 91.9035 48.7669 92.03 48.2598C92.1566 47.7527 92.6628 47.626 93.1691 47.7527L108.483 53.9641C108.99 54.0908 109.117 54.5978 108.99 55.1049C108.864 55.6119 108.357 55.7387 107.851 55.4851Z",
    fill: "#E3EAF2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.456 40.1508L100.636 30.0099C100.003 29.7564 99.7501 29.1226 100.003 28.4888C100.256 27.8549 100.889 27.6015 101.522 27.8549L127.341 37.9958C127.974 38.2494 128.227 38.8831 127.974 39.5169C127.721 40.1508 127.088 40.4043 126.456 40.1508Z",
    fill: "#CED7E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.104 40.0215L98.2318 36.0919C97.5989 35.8385 97.3458 35.2046 97.5989 34.5708C97.8522 33.937 98.4849 33.6835 99.1178 33.937L108.99 37.8666C109.623 38.12 109.876 38.7539 109.623 39.3877C109.37 40.0215 108.611 40.275 108.104 40.0215Z",
    fill: "#CED7E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.72 31.1523L131.772 46.3636C130.885 48.5186 132.152 51.0537 134.177 51.8144L147.718 57.1383",
    fill: "#E6EDF5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_804_55023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9779 33.3029L112.658 87.4298C113.418 89.3312 112.658 91.4861 110.759 92.2466L57.8556 115.571C55.9571 116.331 53.8055 115.571 53.0462 113.669L22.291 43.6974C21.5316 41.7959 22.291 39.641 24.1894 38.8804L62.5385 21.8945L87.9779 33.3029Z",
    fill: "white"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4462 74.8771L63.6785 88.9475C63.2987 89.2011 62.7925 88.9475 62.5394 88.5672C62.2862 88.187 62.5394 87.6799 62.9191 87.4264L94.6868 73.3559C95.0664 73.1025 95.5728 73.3559 95.8259 73.7362C96.079 74.1166 95.8259 74.7503 95.4462 74.8771Z",
    fill: "#E3EAF2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7551 90.5998L54.1863 93.0082C53.8066 93.2617 53.3003 93.0082 53.0472 92.628C52.7941 92.2476 53.0472 91.7406 53.4269 91.4871L58.9957 89.0786C59.3754 88.8251 59.8817 89.0786 60.1348 89.4589C60.3879 89.9659 60.2614 90.473 59.7551 90.5998Z",
    fill: "#E3EAF2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5217 66.3887L77.3465 72.6C76.9667 72.8535 76.4605 72.6 76.2074 72.2198C75.9542 71.8395 76.2074 71.3325 76.5871 71.0789L90.7623 64.8677C91.1419 64.6141 91.6483 64.8677 91.9014 65.2479C92.1545 65.6282 92.0279 66.1352 91.5217 66.3887Z",
    fill: "#E3EAF2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3964 75.2598L50.7663 84.3867C50.3866 84.6401 49.8804 84.3867 49.6273 84.0063C49.3741 83.626 49.6273 83.119 50.007 82.8655L70.6369 73.7388C71.0167 73.4852 71.5229 73.7388 71.776 74.119C72.0292 74.6261 71.9026 75.1331 71.3964 75.2598Z",
    fill: "#E3EAF2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1071 57.6428L82.6648 60.0511C82.2851 60.3047 81.7788 60.0511 81.5257 59.6709C81.2726 59.2906 81.5257 58.7836 81.9054 58.5301L87.3477 56.1216C87.7273 55.868 88.2337 56.1216 88.4868 56.5019C88.7399 57.0089 88.4868 57.516 88.1071 57.6428Z",
    fill: "#E3EAF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4723 62.3303L47.2234 75.7668C46.8437 76.0204 46.3374 75.7668 46.0843 75.3866C45.8312 75.0063 46.0843 74.4992 46.464 74.2458L76.8395 60.8091C77.2192 60.5555 77.7255 60.8091 77.9786 61.1894C78.1051 61.6964 77.9786 62.2035 77.4723 62.3303Z",
    fill: "#E3EAF2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.573 94.9083L73.6746 95.7956C73.2948 96.0491 72.7886 95.7956 72.5355 95.4154C72.2823 95.0351 72.5355 94.5281 72.9152 94.2745L74.8137 93.3872C75.1934 93.1337 75.6996 93.3872 75.9527 93.7674C76.2059 94.1478 75.9527 94.6548 75.573 94.9083Z",
    fill: "#E3EAF2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1321 97.3185L58.8679 102.262C58.4882 102.516 57.9819 102.262 57.7288 101.882C57.4757 101.502 57.7288 100.995 58.1085 100.741L69.3728 95.7973C69.7524 95.5439 70.2588 95.7973 70.5119 96.1776C70.765 96.558 70.6384 97.0649 70.1321 97.3185Z",
    fill: "#E3EAF2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.562 49.0216L65.0711 57.6413C64.6913 57.8948 64.1851 57.6413 63.932 57.2611C63.6788 56.8808 63.932 56.3737 64.3117 56.1202L83.8027 47.5005C84.1823 47.247 84.6885 47.5005 84.9417 47.8807C85.1948 48.261 84.9417 48.7681 84.562 49.0216Z",
    fill: "#E3EAF2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7436 60.4318L43.6824 67.0233C43.3027 67.2769 42.7964 67.0233 42.5433 66.643C42.2902 66.2627 42.5433 65.7557 42.9229 65.5022L57.9841 58.9106C58.3639 58.6572 58.8701 58.9106 59.1232 59.2909C59.3764 59.6712 59.2498 60.1782 58.7436 60.4318Z",
    fill: "#E3EAF2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8931 36.3458L35.4537 47.5008C34.8209 47.7543 34.1881 47.5008 33.9349 46.867C33.6818 46.2332 33.9349 45.5993 34.5678 45.3459L59.8807 34.1909C60.5135 33.9374 61.1463 34.1909 61.3995 34.8247C61.6526 35.4585 61.3995 36.0923 60.8931 36.3458Z",
    fill: "#CED7E2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8574 49.4044L38.1119 53.7143C37.4791 53.9678 36.8462 53.7143 36.5931 53.0805C36.34 52.4466 36.5931 51.8129 37.226 51.5593L46.9714 47.2495C47.6043 46.996 48.237 47.2495 48.4901 47.8833C48.7434 48.3903 48.4901 49.151 47.8574 49.4044Z",
    fill: "#CED7E2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5391 22.0234L69.1205 36.9812C70.0063 39.0093 72.6643 40.0234 74.6892 39.1361L87.9786 33.3051",
    fill: "#E6EDF5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_804_55023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.835 37.4833L127.722 113.54C127.722 116.075 125.697 118.23 123.039 118.23H49.2512C46.72 118.23 44.5684 116.201 44.5684 113.54V15.8073C44.5684 13.2721 46.5934 11.1172 49.2512 11.1172H102.788L126.835 37.4833Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5098 103.02H77.852C77.2191 103.02 76.7129 102.513 76.7129 101.879C76.7129 101.245 77.2191 100.738 77.852 100.738H80.5098C81.1426 100.738 81.6489 101.245 81.6489 101.879C81.6489 102.513 81.1426 103.02 80.5098 103.02Z",
    fill: "#E3EAF2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0421 103.02H57.3481C56.7153 103.02 56.209 102.513 56.209 101.879C56.209 101.245 56.7153 100.738 57.3481 100.738H73.0421C73.6749 100.738 74.1812 101.245 74.1812 101.879C74.1812 102.513 73.6749 103.02 73.0421 103.02Z",
    fill: "#E3EAF2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5468 27.0891H58.1087C57.3493 27.0891 56.5898 26.4554 56.5898 25.568C56.5898 24.8074 57.2227 24.0469 58.1087 24.0469H93.5468C94.3062 24.0469 95.0655 24.6807 95.0655 25.568C94.9389 26.4554 94.3062 27.0891 93.5468 27.0891Z",
    fill: "#CED7E2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.651 35.5813H58.1087C57.3493 35.5813 56.5898 34.9475 56.5898 34.0601C56.5898 33.2996 57.2227 32.5391 58.1087 32.5391H71.651C72.4105 32.5391 73.1699 33.1728 73.1699 34.0601C73.0432 34.9475 72.4105 35.5813 71.651 35.5813Z",
    fill: "#CED7E2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M102.785 11.2461V32.1617C102.785 35.0771 105.316 37.4856 108.227 37.4856H126.832",
    fill: "#E6EDF5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M115.191 51.5547H96.7124C96.7124 51.5547 96.7124 51.5547 96.5858 51.5547C96.5858 51.5547 96.5858 51.5547 96.4593 51.5547H77.4746C77.4746 51.5547 77.4746 51.5547 77.3481 51.5547C77.3481 51.5547 77.3481 51.5547 77.2215 51.5547H59.3758C57.3509 51.5547 55.832 53.2025 55.832 55.2307V87.4279C55.832 89.456 57.4774 91.104 59.3758 91.104H115.065C117.089 91.104 118.608 89.456 118.608 87.4279V55.2307C118.734 53.2025 117.089 51.5547 115.191 51.5547ZM78.4872 80.0758V72.8505H95.5733V80.0758H78.4872ZM95.5733 82.2307V88.9491H78.4872V82.2307H95.5733ZM95.5733 63.3434V70.5688H78.4872V63.3434H95.5733ZM78.4872 61.1885V53.7096H95.5733V61.1885H78.4872ZM116.583 70.5688H97.7249V63.3434H116.583V70.5688ZM76.3355 70.5688H57.9836V63.3434H76.209V70.5688H76.3355ZM57.9836 72.8505H76.209V80.0758H57.9836V72.8505ZM97.7249 72.8505H116.583V80.0758H97.7249V72.8505ZM116.583 55.2307V61.1885H97.7249V53.7096H115.191C115.95 53.7096 116.583 54.3434 116.583 55.2307ZM59.3758 53.7096H76.209V61.1885H57.9836V55.2307C57.9836 54.3434 58.6165 53.7096 59.3758 53.7096ZM57.9836 87.4279V82.2307H76.209V88.9491H59.3758C58.6165 88.9491 57.9836 88.3152 57.9836 87.4279ZM115.191 88.9491H97.7249V82.2307H116.583V87.4279C116.583 88.3152 115.95 88.9491 115.191 88.9491Z",
    fill: "#E3EAF2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_804_55023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.721 73.4239C110.721 75.2623 110.476 77.1007 110.109 78.8166C109.865 79.9197 109.498 80.9001 109.131 81.8806C106.805 88.0088 101.911 92.9109 95.793 95.2397C95.3036 95.3624 94.9364 95.6078 94.447 95.7305C92.1222 96.4655 89.7973 96.8335 87.2277 96.8335C74.2575 96.8335 63.7344 86.2928 63.7344 73.3014C63.7344 60.3098 74.2575 49.7695 87.2277 49.7695C100.198 49.892 110.721 60.4323 110.721 73.4239Z",
    fill: "#7D63EC"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M110.108 79.4296C109.862 80.4101 109.495 81.3906 109.129 82.3711C106.804 88.2541 102.154 92.9111 96.2809 95.2399L83.0659 82.0033L81.2305 80.165L94.2007 68.5216L98.4837 66.0703L109.985 77.5911L110.108 79.4296Z",
    fill: "url(#paint0_linear_804_55023)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7809 82.6154C84.0466 82.6154 83.3125 82.3702 82.8231 81.7574L77.4392 76.3647C76.338 75.2616 76.338 73.5458 77.4392 72.4427C78.5404 71.3396 80.2535 71.3396 81.3548 72.4427L84.7809 75.8744L94.5697 66.0695C95.671 64.9664 97.3845 64.9664 98.4854 66.0695C99.5862 67.1725 99.5862 68.8885 98.4854 69.9915L86.7386 81.7574C86.2492 82.3702 85.515 82.6154 84.7809 82.6154Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_804_55023",
    x: 43.8125,
    y: 4.53906,
    width: 125.905,
    height: 143.672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_804_55023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_804_55023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_804_55023",
    x: 0,
    y: 10.8945,
    width: 134.949,
    height: 137.969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_804_55023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_804_55023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_804_55023",
    x: 22.5684,
    y: 0.117188,
    width: 127.153,
    height: 151.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_804_55023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_804_55023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_804_55023",
    x: 55.7344,
    y: 46.7695,
    width: 62.9868,
    height: 63.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_804_55023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_804_55023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_804_55023",
    x1: 89.4837,
    y1: 72.7079,
    x2: 99.3657,
    y2: 82.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#657EFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalImg);
export default __webpack_public_path__ + "static/media/modal-img.c2519d8d2e588c3fa4ac4663954a09c3.svg";
export { ForwardRef as ReactComponent };